import { useRef, useState, useEffect } from "react";
import useIsMobile from "../hooks/useIsMobile";
import StartAudio from '../images/icons/image-card-icons/card-icon-start.svg'
import StopAudio from '../images/icons/image-card-icons/card-icon-stop.svg'
import SoundWave from '../images/audio-wave.svg'
import cardAdd from '../images/icons/image-card-icons/card-icon-add-to-collection.svg';
import cardInCollection from '../images/icons/image-card-icons/card-icon-add-to-collection-active.svg';
import cardRemove from '../images/icons/image-card-icons/card-icon-remove.svg';
import cardCopy from '../images/icons/image-card-icons/card-icon-copy-image.svg';
import cardCopyDescription from '../images/icons/image-card-icons/card-icon-copy-description.svg';
import cardSave from '../images/icons/image-card-icons/card-icon-save-image.svg';
import cardSaveDescription  from '../images/icons/image-card-icons/card-icon-save-description.svg';
import cardPopulatePrompt from '../images/icons/image-card-icons/card-icon-populate-prompt.svg';
import cardZoom from '../images/icons/image-card-icons/card-icon-zoom-in.svg';
import cardShare from '../images/icons/image-card-icons/card-icon-share-to-community.svg';
import cardTag from '../images/icons/image-card-icons/card-icon-tag.svg';
import cardPublic  from '../images/icons/image-card-icons/card-icon-public.svg';
import cardPrivate  from '../images/icons/image-card-icons/card-icon-private.svg';
import cardEye from '../images/icons/image-card-icons/card-icon-eye.svg';
import cardImageDescribe from '../images/icons/image-card-icons/card-icon-describe-image.svg';
import cardEdit from '../images/icons/image-card-icons/card-icon-edit.svg'
import closeIcon from "../images/icons/white-close.svg";
import uploadIconWhite from "../images/icons/input-bar-icons/icon-input-bar-upload-white.svg";
import { db } from "../db";
import { useDriverContextDispatch } from "../context/DriverContext";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useAccountContext } from "../context/AccountContext";
import { usePromptusAPIState } from "../context/PromptusAPIContext";
import Swal from "sweetalert2";
import CollectSound from "../sounds/collect.flac";
import { getImageMetadata, updateAccount, deleteCollectionImage, getImageDescription, changeImageVisibility, updateImageTags, getAuthorizationToken, getUseDepApi, getPromptFileData, getGenerateOutput } from "../api-helper";
import eventBus from "../utils/eventBus";
import { useNavigate } from "react-router-dom";
import { Modal } from 'react-responsive-modal';
import { copyDescriptionToClipboard, downloadDescriptionAsPromptFile, populatePromptField } from './ImageDescriptionUtils';
import { usePromptContext } from "../context/PromptContext";
import Select, {InputAction} from 'react-select';
import ToggleInput from "./inputs/ToggleInput";
import makeAnimated from 'react-select/animated'
import { isUndefined } from "cropperjs";
import electronBridge from '../utils/electronBridge';
import { ReactComponent as CardSave } from '../images/icons/image-card-icons/card-icon-save-image.svg';

const animatedComponents = makeAnimated()

export async function downloadString(text, fileType, fileName) {
    const blob = new Blob([text], { type: fileType });
    const ext = fileName.split('.').pop();

    if (window.showSaveFilePicker && !electronBridge.isElectron) {
        try {
            const handle = await window.showSaveFilePicker({
                suggestedName: fileName,
                types: [{ description: `${ext.toUpperCase()} File`, accept: { [fileType]: [`.${ext}`] } }]
            });
            const writable = await handle.createWritable();
            await writable.write(blob);
            await writable.close();
            return;
        } catch (err) {
            if (err.name === 'AbortError') return;
            console.warn('showSaveFilePicker failed, falling back:', err);
        }
    }

    const a = document.createElement('a');
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
}

export default function Audio(props) {
  // const [audioSrc, setAudioSrc] = useState(props.image);
  const [isPlaying, setIsPlaying] = useState(false);
  const [userClickedPlay, setUserClickedPlay] = useState(false);
  const [progress, setProgress] = useState(0);
  const [volume, setVolume] = useState(0.5);
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const [showAudioControls, setShowAudioControls] = useState(false);
  const [enableAutoSound, setEnableAutoSound] = useState(false);
  const audioRef = useRef(null);
  const [showMobileToolbar, setShowMobileToolbar] = useState(false);
  const isMobile = useIsMobile();
  const toolbarRef = useRef(null);
  const menuButtonRef = useRef(null);

  const [localInCollection, setLocalInCollection] = useState(props.inCollection);
  const [privateImage, setPrivateImage] = useState(true);
  const [visibility, setVisibility] = useState("");
  const navigate = useNavigate();
  const [promptInfo, setPromptInfo] = useState({});
  const [openDescribeImage, setOpenDescribeImage] = useState(false);
  const [clipboardMessage, setClipboardMessage] = useState('');    
  const [imageDescriptionLoading, setImageDescriptionLoading] = useState(false);
  const [imageDescription, setImageDescription] = useState("");
  const [downloadName, setDownloadName] = useState(`Promptus_${props.uid}`)
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]); 
  const [tag, setTag] = useState("");
  const [clearTags, setClearTags] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputTag, setInputTag] = useState("");
  const [tagLoading, setTagLoading] = useState(false);
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [hasAudioField, setHasAudioField] = useState(true);
  const [currentSchema, setCurrentSchema] = useState({});
  const [localAudioOverride, setLocalAudioOverride] = useState(null);

  const driverContextDispatch = useDriverContextDispatch();
  const collectionContextDispatch = useCollectionContextDispatch();
  const collectionContext = useCollectionContext();
  const accountContext = useAccountContext();
  const apiState = usePromptusAPIState();
  const { updatePrompt } = usePromptContext();

  const toFileUrl = (filePath) => {
    return filePath;
  }

useEffect(() => {
  setPromptInfo({prompt: props.prompt})
  if (props.public && props.public == "1") {
    setVisibility("Public");
    setPrivateImage(false);
} else {
    setVisibility("Private")
    setPrivateImage(true);
}

  if (props.tag) {
    setTag(props.tag);
  }

  // Close volume slider when clicking outside
    const handleClickOutside = (e) => {
      if (!e.target.closest(".volume-control")) {
        setShowVolumeSlider(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
},[])

useEffect(() => {
    const convertBase64ToUrl = async () => {
        if (electronBridge.isElectron) {
            return;
        }

        const isAudioUrl = props.image && (props.image.startsWith('http://') || props.image.startsWith('https://'));

        if (!isAudioUrl && props.uid && props.hash && props.image) {
            try {
                console.log('[Audio] Base64 audio detected, fetching URL from API...');
                const result = await getGenerateOutput(props.uid, props.hash);
                console.log('[Audio] Response from API: ', result);

                if (result.url && result.url.trim() !== '') {
                    console.log('[Audio] Successfully retrieved URL from API:', result.url);

                    await db.images.where('hash').equals(props.hash).modify({ image: result.url });
                    await db.collectedImages.where('hash').equals(props.hash).modify({ image: result.url });

                    setLocalAudioOverride(result.url);
                }
            } catch (error) {
                console.error('[Audio] Error fetching URL from API:', error);
            }
        }
    };

    convertBase64ToUrl();
}, [props.image, props.uid, props.hash]);

// Handle click outside for mobile toolbar
useEffect(() => {
    if (!isMobile) return;

    const handleClickOutside = (event) => {
        if (
            toolbarRef.current && 
            !toolbarRef.current.contains(event.target) &&
            menuButtonRef.current &&
            !menuButtonRef.current.contains(event.target)
        ) {
            setShowMobileToolbar(false);
        }
    };

    if (showMobileToolbar) {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('touchstart', handleClickOutside);
    };
}, [showMobileToolbar, isMobile]);

// Load enable_auto_sound setting
useEffect(() => {
    const loadAutoSoundSetting = async () => {
        try {
            const setting = await db.settings.where('key').equals('enable_auto_sound').first();
            if (setting) {
                setEnableAutoSound(setting.value);
            } else {
                // Default to false if setting doesn't exist
                setEnableAutoSound(false);
            }
        } catch (error) {
            console.error('Error loading auto sound setting:', error);
            setEnableAutoSound(false);
        }
    };

    loadAutoSoundSetting();
}, []);

// Apply volume when audio element becomes ready
useEffect(() => {
  const applyVolume = () => {
    if (audioRef.current && audioRef.current.readyState >= 1) {
      try {
        audioRef.current.volume = volume;
      } catch (error) {
        console.error('Error applying initial volume:', error);
      }
    }
  };

  if (audioRef.current) {
    // Apply immediately if already loaded
    applyVolume();

    // Listen for load events
    audioRef.current.addEventListener('loadeddata', applyVolume);
    audioRef.current.addEventListener('canplay', applyVolume);

    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('loadeddata', applyVolume);
        audioRef.current.removeEventListener('canplay', applyVolume);
      }
    };
  }
}, [volume]);

// Listen for schema updates to determine if useAudio button should be shown
useEffect(() => {
    const handleSchemaUpdate = (schemaInfo) => {
        console.log('[Audio] Received schema update:', schemaInfo);
        // Check if schema has any audio URL input fields
        let hasAudio = false;
        for (const [key, field] of Object.entries(schemaInfo.schema || {})) {
            if (field.type === 'url' && field.audio_upload === true) {
                hasAudio = true;
                break;
            }
        }
        setHasAudioField(hasAudio);
        setCurrentSchema(schemaInfo.schema || {});
    };

    eventBus.on('schemaUpdate', handleSchemaUpdate);

    // Request current schema on mount in case it was emitted before this component mounted
    eventBus.emit('requestSchema');

    return () => eventBus.off('schemaUpdate', handleSchemaUpdate);
}, []);

async function getMediaType(base64String, returnExtension = false) {
    try {
        const cleaned = base64String.trim().replace(/\s/g, '');
        const padded = cleaned + '==='.slice((cleaned.length + 3) % 4);
        const binaryStr = atob(padded);
        const bytes = new Uint8Array(binaryStr.length);

        for (let i = 0; i < binaryStr.length; i++) {
            bytes[i] = binaryStr.charCodeAt(i);
        }

        // Generate long hex string from first 32 bytes
        const hex = Array.from(bytes.slice(0, 32))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');

        console.log('First 32 bytes hex:', hex);

        // Signature map with both MIME type and file extension
        const signatures = [
            { type: 'video/mp4', hex: '6674797069736f6d', ext: 'mp4' },
            { type: 'video/mp4', hex: '667479706d703432', ext: 'mp4' },
            { type: 'image/png', hex: '89504e47', ext: 'png' },
            { type: 'image/jpeg', hex: 'ffd8ff', ext: 'jpg' },
            { type: 'image/webp', hex: '52494646', ext: 'webp' },
            { type: 'audio/mpeg', hex: '494433', ext: 'mp3' },
            { type: 'video/webm', hex: '1a45dfa3', ext: 'webm' },
            { type: 'audio/ogg', hex: '4f676753', ext: 'ogg' },
            { type: 'audio/wav', hex: '52494646', ext: 'wav' },
            { type: 'application/pdf', hex: '25504446', ext: 'pdf' },
        ];

        const matched = signatures.find(sig => hex.includes(sig.hex.toLowerCase()));
        const mimeType = matched?.type || 'Unknown Media Type';
        const extension = matched?.ext || 'unknown';

        if (returnExtension) return extension;

        if (mimeType.startsWith("image/")) return "Image";
        if (mimeType.startsWith("video/")) return "Video";
        if (mimeType.startsWith("audio/")) return "Audio";

        console.log(`getMediaType returns ${mimeType}`);
        return mimeType;
    } catch (err) {
        console.error("Error parsing base64:", err);
        return returnExtension ? 'invalid' : "Invalid Base64 String";
    }
}

/**
 * Tries to grab the collection image with the given uid
 * @returns {Promise<*>}
 */
const getSpecificImage = async (uid) => {
  return await db.collection
      .where('uid')
      .equals(uid)
      .first();
}

const toggleCollection = async () => {
  console.log(`AUDIO - toggleCollection`);
    
    if (accountContext.loggedIn === false) {
        Swal.fire({
            title: "Not Logged In",
            text: "You need to be logged in to add images to your collection. Please login to your account to proceed.",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#FFB02E",
        }).then((result) => {
            if (result.isConfirmed) {
                navigate('/profile')
            }
        })
        return;          
    }

    // Set the toggle lock
    await db.settings.put({ key: 'toggleLock', value: true });

    // Pre-loading Sound File and setting check
    const collectAudio = new window.Audio(CollectSound);
    const soundSettingCheck = await db.settings.where('key').equals('play_sounds').first()

    try{
    const inCollection = !props.inCollection;

    let inPlayground = false;
    let propsId = props.id;
    await db.images.where('image').equals(props.image).toArray(async(images) => {
        if (images.length > 0) {
            propsId = images[0].id;
            inPlayground = true;
        }
    });

    await db.images
        .update(propsId, {inCollection})
        .then(async () => {
            await db.collectedImages.where('hash').equals(props.hash).count(async(imageCount) => {
                if (imageCount > 0) {
                    // removing the image from the collection
                    if (!inCollection) {
                        if (!inPlayground) {
                            await db.collectedImages.where('image').equals(props.image).toArray(async(collectedImage) => {
                                if (collectedImage.length > 0) {
                                    console.log("Adding image to playground");
                                    // THIS SHOULD BE IN THE SAME FORMAT AS getPromptFileData
                                    await getImageMetadata(accountContext.accountDetails.accountNo, collectedImage[0].hash)
                                        .then((prompt) => {
                                            db.collection.put({
                                                uid: collectedImage[0].uid,
                                                prompt : prompt.prompt,
                                                queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                                                timestamp: Date.now(),
                                            });
                                        })
                                        .finally(() => {
                                            console.log("Added image history to local db");
                                        })

                                    await db.images.put({
                                       image : collectedImage[0].image,
                                       seed: collectedImage[0].seed,
                                       uid: collectedImage[0].uid,
                                       model: collectedImage[0].model,
                                       inCollection: false,
                                       hash: collectedImage[0].hash,
                                       online: collectedImage[0].online,
                                        tag: collectedImage[0].tag
                                   });
                                }
                            });
                        }


                        db.collectedImages.where('image').equals(props.image).delete();
                        console.log("Removing image from collection DB");
                        deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                        props.refreshImages()
                    }
                } else {
                    // adding the image to the collection
                    let iCount
                    await db.collectedImages.count((collectedCount) => {
                        iCount = collectedCount + 1;
                    })
                    console.log("Adding image to collection DB: ", iCount);
                    console.log(props);

                    // db.collectedImages.put({uid: props.uid, imageID: iCount, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false, dataType: props.dataType, timestamp: Date.now()})

                    getSpecificImage(props.uid).then(async(image) => {
                        // let fileExt = ''

                        // if (!props.image.includes('://') || !props.image.includes(':\\') || !props.image.includes('http')) {
                        //     fileExt = await getMediaType(props.image, false)
                        // }

                        let imageArr = [{
                            uid: props.uid,
                            image: props.image,
                            seed: props.seed,
                            model: props.model,
                            hash: props.hash,
                            online: props.online,
                            tag: props.tag,
                            prompt:promptInfo.prompt,
                            dataType: "audio"
                        }]
                        let colArr = null
                        if (image) {
                            colArr = JSON.stringify([image])
                        }
                        console.log("Going through the update API call: ", imageArr, " | ", colArr);
                        if (electronBridge.isElectron && props.image.includes('://') || props.image.includes(':\\')) {
                            const tokens = getAuthorizationToken();
                            const devAPI = await getUseDepApi();
                            
                            const response = electronBridge.ipcRenderer.invoke('collection_upload', JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr, tokens, devAPI);
                            console.log('Collecion Upload Response: ', response);
                            
                        } else {
                            updateAccount(JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, colArr)
                        }
                    });
                }
            });
            // props.refreshImages();
        }).then(async () => {
            setLocalInCollection(!localInCollection);
            if (soundSettingCheck.value && inCollection) {
                // const collectAudio = new Audio(CollectSound);
                collectAudio.loop = false;
                collectAudio.volume = 0.8;
                collectAudio.play();
            }
        });
    // Add a delay to ensure API processing
    await new Promise(resolve => setTimeout(resolve, 2000));
  } finally {
      // Release the toggle lock
      await db.settings.put({ key: 'toggleLock', value: false });
  }
}

const handleDescribeImage = async() => {
  console.log("Describe the image")

  setOpenDescribeImage(true)
  setImageDescription("Generating ...");
  setImageDescriptionLoading(true);

  let imageDescription = "";
  const item = await db.imageDescriptions.where('hash').equals(props.hash).first();

  if (item) {
      console.log("Pulling description from local db")
      imageDescription = item.description
      setImageDescription(imageDescription);
  } else {
      console.log("Pulling description from api")

      let imageDescription ;
      
      if (props.inCollection) {
          imageDescription = getImageDescription(accountContext.accountDetails.accountNo, props.hash, "")
      } else {
          imageDescription = getImageDescription(accountContext.accountDetails.accountNo, "", props.image)
      }
      
      imageDescription.then((description) => {
          console.log(description)
          if (description.image_description !== undefined) {
              imageDescription = description.image_description;

              if (imageDescription.length > 0) {
                  setImageDescription(imageDescription);
                  setImageDescriptionLoading(false);
                  db.imageDescriptions.put({
                      hash: props.hash,
                      description: imageDescription,
                      timestamp: Date.now()
                  });
              }
          }
      });
  }
}

const handlePromptPopulation = () => {
  populatePromptField(imageDescription, updatePrompt)
  setOpenDescribeImage(false)
}

const handlePrivatePublic = async() => {
    if (accountContext.accountDetails.alias !== "") {
        setPrivateImage(!privateImage);
        if (!privateImage) {
            setVisibility("Private")
            console.log('Entire props during handle private public: ', props)
            console.log("Changing Image Visibility Route: ", props.hash);
            await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 0)
            .then(() => {
                console.log("Image Visibility Changed Successfully");
            })
            .catch((e) => {
                console.log("Image Visibility did not change");
                setVisibility("Public")
                setPrivateImage(!privateImage);
            })
            // await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false}).then(async(updated) => {
            //     if (updated) {
            //         setVisibility("Private")
            //         console.log("Changing Image Visibility Route: ", props.hash);
            //         await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 0)
            //         .then(() => {
            //             console.log("Image Visibility Changed Successfully");
            //         })
            //         .catch((e) => {
            //             console.log("Image Visibility did not change");
            //             setVisibility("Public")
            //             setPrivateImage(!privateImage);
            //         })
            //         // props.refreshImages();
            //     }
            // })
        } else {
            setVisibility("Public")
            console.log("Changing Image Visibility Route: ", props.hash);
            await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1)
            .then(() => {
                console.log("Image Visibility Changed Successfully");
            })
            .catch((e) => {
                console.log("Image Visibility did not change");
                setVisibility("Private")
                setPrivateImage(!privateImage);
            })
            // await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: true}).then(async(updated) => {
            //     if (updated) {
            //         setVisibility("Public")
            //         console.log("Changing Image Visibility Route: ", props.hash);
            //         await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1)
            //         .then(() => {
            //             console.log("Image Visibility Changed Successfully");
            //         })
            //         .catch((e) => {
            //             console.log("Image Visibility did not change");
            //             setVisibility("Private")
            //             setPrivateImage(!privateImage);
            //         })
            //         // props.refreshImages();
            //     }
            // })
        }
    } else {
        Swal.fire({
            title: "No Username",
            text: "You need to have an username in order to make your images available to the public. Please login in to the website and set yourself a username before proceeding.",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#FFB02E",
        }).then((result) => {
            if (result.isConfirmed) {
                window.open("https://login.promptus.ai/account", "_blank")
            }
        })
    }
}

const editTagOnImage = () => {
  setTagLoading(true);
  let multiOptions = "";
  let initTag
  let concate

  setTimeout(() => {
      if (isUndefined(props.tag) == false) {
          if (clearTags == false) {
              initTag = props.tag + ","
          } else {
              initTag = "";
          }
      } else {
          initTag = "";
      }

      console.log(`Init Tag: ${initTag}`);

      if (selectedOptions !== "" && !selectedOptions.includes("undefined")) {
          selectedOptions.map((arrValue) => {

              if (!initTag.includes(arrValue.value) || clearTags == true){
                  console.log(`Adding Tag: ${arrValue.value}`);
                  multiOptions += arrValue.value + ",";
              }
          })
          initTag += multiOptions;
      }


  }, 1000)

  setTimeout(() => {
      if (inputTag !== "") {
          if (!initTag.includes(inputTag)){
              concate = initTag + inputTag
          } else {
              concate = initTag
          }
      } else {
          concate = initTag;
      }   

      console.log(`Init Tag: ${initTag}`);
      console.log(`Input Tag: ${inputTag}`);

      if (concate.endsWith(',')) {
          concate = concate.slice(0, -1);
      }
      if (concate.startsWith(',')) {
          concate = concate.substring(1);
      }
      if (concate == '') {
          Swal.fire({
              color: "#190A4E",
              title: "Tag Empty",
              text: "You cannot tag an image with an empty tag. Please add a tag to the image before proceeding.",
              icon: "info",
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false
          })
          setTagLoading(false);
          return;
      }  
      setTag(concate)

      console.log(`Concatenated Tag: ${concate}`);
      
      props.dbTable.update(props.id, {tag: concate}).then(async(updated) => {
          if (updated) {
              if (props.isMyCollection) {
                  // Update the tag in the images table if it exists
                  let generatedImages = [];
                  await db.images.reverse().toArray((images) => {
                      generatedImages = images;
                  });
                  let imageInImagesTable;
                  generatedImages.forEach((image) => {
                      if (image.hash === props.hash) {
                          imageInImagesTable = image;
                      }
                  })
                  if (imageInImagesTable) {
                      db.images.update(imageInImagesTable.id, { tag: concate });
                  } else {
                      console.log("Image not found in the images table");
                  }
                  console.log("Update Image Tags Route: ", props.hash);
                  updateImageTags(accountContext.accountDetails.accountNo, props.hash, concate)

              } else {
                  let collectionImages = [];
                  await db.collectedImages.reverse().toArray((images) => {
                      collectionImages = images;
                  });
                  let imageInCollectionTable;
                  collectionImages.forEach((image) => {
                      if (image.hash === props.hash) {
                          imageInCollectionTable = image;
                      }
                  })
                  if (imageInCollectionTable) {
                      db.collectedImages.update(imageInCollectionTable.id, { tag: concate });
                  } else {
                      console.log("Image not found in the collection table");
                  }
              }
              Swal.fire({
                  title:"Success",
                  text:"Your image was successfully tagged",
                  icon:"success",
                  timer: 1000,
                  showConfirmButton: false
              }).then(() => {
                  setTagLoading(false);
                  setInputTag("");
                  setClearTags(false);
                  setSelectedOptions([]);
                  props.refreshTags();
                  if (!props.isMyCollection) {
                      props.refreshImages();
                  }
                  // props.refreshImages();
              })
              setOpen(false)
          }
      })

  }, 2500)

}

const handleClearTag = () => {
  setClearTags(!clearTags);
}

const handleTagging = () => {
  setOptions([]);

  const combinedTags = [...collectionContext.tags, ...collectionContext.collectionTags];
  const uniqueTags = [...new Set(combinedTags)];

  const sortedTags = uniqueTags.sort((a, b) => a.localeCompare(b));
  setOptions(sortedTags.map(tag => ({ value: tag, label: tag })));
  setOpen(true)
}

const handleEnter = (e) => {
  if (e.key === "Enter") {
      editTagOnImage();
  }
}

const deleteImage = async () => {
  let imageNotFound = false;
  if (props.isMyCollection) {
      db.collectedImages
          .where("id")
          .equals(props.id)
          .delete()
          .then(async () => {
              console.log("check if video is in generated videos and remove the flag");
              // check if image is in generated images and remove the flag
              await db.images.where('image').equals(props.image).toArray(async(images) => {
                  if (images.length > 0) {
                      // removing the image from the collection
                      db.images.update(images[0].id, {inCollection: false})
                      console.log("Removing image from collection");
                      Swal.fire({
                          color: "#190A4E",
                          title: "Confirm Delete",
                          text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                          icon: "info",
                          confirmButtonText: 'Yes',
                          confirmButtonColor: "#FFB02E",
                          showDenyButton: true,
                          denyButtonText: "No",
                          denyButtonColor: "#190A4E",
                      }).then((result) => {
                          if (result.isConfirmed) {
                              deleteCollectionImage(accountContext.accountDetails.accountNo, images[0].hash)
                              .then((data) => props.refreshImages())
                          }
                      })
                  } else {
                      imageNotFound = true;
                  }
              });
              if (imageNotFound) {
                  Swal.fire({
                      color: "#190A4E",
                      title: "Confirm Delete",
                      text: `Are you sure you want to delete this video from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                      icon: "info",
                      confirmButtonText: 'Yes',
                      confirmButtonColor: "#FFB02E",
                      showDenyButton: true,
                      denyButtonText: "No",
                      denyButtonColor: "#190A4E",
                  }).then((result) => {
                      if (result.isConfirmed) {
                          deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                          .then((data) => props.refreshImages())
                      }
                  })
              }
          });
      return;
  }
  Swal.fire({
      color: "#190A4E",
      title: "Confirm Delete",
      text: `Are you sure you want to delete this video from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
      icon: "info",
      confirmButtonText: 'Yes',
      confirmButtonColor: "#FFB02E",
      showDenyButton: true,
      denyButtonText: "No",
      denyButtonColor: "#190A4E",
  }).then((result) => {
      if (result.isConfirmed) {
          db.images
          .where("id")
          .equals(props.id)
          .delete()
          .then(props.refreshImages);
      }
  })

}

  // Handle auto-play on hover
  const handleMouseEnter = async () => {
    // Show audio controls
    setShowAudioControls(true);

    // Only auto-play if the setting is enabled
    if (enableAutoSound && audioRef.current && audioRef.current.paused) {
      try {
        await audioRef.current.play();
      } catch (error) {
        // Ignore interruption errors
        if (error.name !== 'AbortError') {
          console.error('Audio auto-play error:', error);
        }
      }
    }
  };

  const handleMouseLeave = () => {
    // Hide audio controls
    setShowAudioControls(false);

    // Only auto-pause if:
    // 1. Auto-sound is enabled AND
    // 2. User didn't manually click play AND
    // 3. Audio is currently playing
    if (enableAutoSound && !userClickedPlay && audioRef.current && !audioRef.current.paused) {
      try {
        audioRef.current.pause();
        audioRef.current.currentTime = 0; // Reset to the beginning
      } catch (error) {
        console.error('Audio pause error:', error);
      }
    }
  };

  // Handle Play/Pause
  const togglePlay = async () => {
    if (audioRef.current) {
      if (isPlaying) {
        try {
          audioRef.current.pause();
          setUserClickedPlay(false); // User intentionally stopped playback
        } catch (error) {
          console.error('Audio pause error:', error);
        }
      } else {
        try {
          await audioRef.current.play();
          setUserClickedPlay(true); // User intentionally started playback
        } catch (error) {
          // Ignore interruption errors
          if (error.name !== 'AbortError') {
            console.error('Audio play error:', error);
          }
          return; // Don't update state if play failed
        }
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Handle audio end - reset user intent when audio finishes naturally
  const handleAudioEnd = () => {
    setIsPlaying(false);
    setUserClickedPlay(false); // Reset user intent when audio ends
  };

  // Update Progress Bar
  const updateProgress = () => {
    if (audioRef.current) {
      const progressPercent = (audioRef.current.currentTime / audioRef.current.duration) * 100;
      setProgress(progressPercent);
    }
  };

  // Seek Audio Manually
  const handleSeek = (e) => {
    if (audioRef.current) {
      const newTime = (e.target.value / 100) * audioRef.current.duration;
      audioRef.current.currentTime = newTime;
      setProgress(e.target.value);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };
  
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    console.log('Volume change event triggered. Raw value:', e.target.value, 'Parsed:', newVolume);
    console.log('Event target:', e.target);
    console.log('Current volume state:', volume);

    // Validate volume range
    if (isNaN(newVolume) || newVolume < 0 || newVolume > 1) {
      console.warn('Invalid volume value:', newVolume);
      return;
    }

    // Check if audio element is ready
    if (audioRef.current && audioRef.current.readyState >= 1) {
      try {
        audioRef.current.volume = newVolume;
        setVolume(newVolume);
        console.log('Volume successfully set to:', newVolume, 'Audio volume:', audioRef.current.volume);
      } catch (error) {
        console.error('Error setting audio volume:', error);
        // Revert to previous volume if setting fails
        if (audioRef.current) {
          e.target.value = volume;
        }
      }
    } else {
      console.warn('Audio element not ready for volume change. Ready state:', audioRef.current?.readyState);
      // Still update the state for UI consistency
      setVolume(newVolume);
      console.log('Volume state updated (audio not ready):', newVolume);
    }
  };

  const getBlobFromSource = async (source, contentType) => {
    if (!source) {
      throw new Error("No source provided");
    }
  
    // 1) If it looks like a URL (http, https, /, blob:)
    const looksLikeUrl =
      source.startsWith("http://") ||
      source.startsWith("https://") ||
      source.startsWith("/") ||
      source.startsWith("blob:");
  
    if (looksLikeUrl) {
      // Fetch the file from the URL
      const response = await fetch(source);
      if (!response.ok) {
        throw new Error("Failed to fetch file: " + response.status);
      }
      // Let the browser decide contentType from the response,
      // or override if you really want
      const blob = await response.blob();
      if (contentType) {
        return blob.slice(0, blob.size, contentType);
      }
      return blob;
    }
  
    // 2) Otherwise assume it's base64
  
    // If it's a data URL like "data:image/png;base64,AAAA..."
    const base64Part = source.includes(",") ? source.split(",")[1] : source;
  
    return base64toBlob(base64Part, contentType);
  };

const base64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

const downloadAudio = async (contentType, ext) => {
    const blobFile = await getBlobFromSource(props.image, contentType);

    if (window.showSaveFilePicker) {
        try {
            const handle = await window.showSaveFilePicker({
                suggestedName: `${downloadName}.${ext}`,
                types: [{ description: `${ext.toUpperCase()} Audio`, accept: { [contentType]: [`.${ext}`] } }]
            });
            const writable = await handle.createWritable();
            await writable.write(blobFile);
            await writable.close();
            return;
        } catch (err) {
            if (err.name === 'AbortError') return;
            console.warn('showSaveFilePicker failed, falling back:', err);
        }
    }

    const blobUrl = URL.createObjectURL(blobFile);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${downloadName}.${ext}`;
    document.body.appendChild(link);
    link.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
    }));
    document.body.removeChild(link);
};

//   const downloadAudio = (contentType, ext) => {
//     // https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
    
//     const blobFile = base64toBlob(props.image, contentType);
//     const blobUrl = URL.createObjectURL(blobFile);
//     const link = document.createElement("a");
//     link.href = blobUrl;
//     link.download = `${downloadName}.${ext}`;
//     document.body.appendChild(link);
//     link.dispatchEvent(new MouseEvent('click', {
//         bubbles: true,
//         cancelable: true,
//         view: window
//     }));
//     document.body.removeChild(link);
// };

const downloadPrompt = async () => {
    console.log("DOWNLOADING PROMPT")
    const item = await db.collection.where('uid').equals(props.uid).first();

    if (item) {
        downloadString(JSON.stringify(item), 'application/json', `${downloadName}.prompt`);
    } else {
        // THIS SHOULD BE IN THE SAME FORMAT AS getImageMetadata
        getPromptFileData(accountContext.accountDetails.accountNo, props.uid).then((prompt) => {
            console.log(prompt)
            db.collection.put({
                uid: prompt.uid,
                prompt : prompt,
                queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                timestamp: Date.now(),
            });
            downloadString(JSON.stringify(prompt), 'application/json', `${downloadName}.prompt`);
        });
    }

}

    // Handle opening file in explorer
    const handleViewInExplorer = async () => {
        try {
            if (!electronBridge.isElectron) {
                console.warn('View in explorer is only available in the desktop app');
                return;
            }
            
            // Check if image is a file path
            if (props.image && (props.image.includes(':\\') || props.image.includes('://'))) {
                console.log('Opening file location:', props.image);
                
                // Clean up the file path (remove file:// prefix if present)
                let filePath = props.image;
                if (filePath.startsWith('file://')) {
                    filePath = filePath.replace('file:///', '').replace('file://', '');
                    // Handle URL encoded characters if any
                    filePath = decodeURIComponent(filePath);
                }
                
                // Use IPC to request main process to open and focus the explorer
                // This allows the main process to use additional APIs for focusing
                if (electronBridge.ipcRenderer) {
                    electronBridge.ipcRenderer.invoke('show-item-in-folder', filePath);
                } else {
                    // Fallback to direct shell module if IPC not available
                    const { shell } = window.require('electron');
                    shell.showItemInFolder(filePath);
                    
                    // Try to bring focus using exec command on Windows
                    const { exec } = window.require('child_process');
                    const path = window.require('path');
                    
                    // On Windows, use explorer with /select flag which should bring focus
                    if (process.platform === 'win32') {
                        const normalizedPath = path.normalize(filePath);
                        exec(`explorer.exe /select,"${normalizedPath}"`, (error) => {
                            if (error) {
                                console.error('Error focusing explorer:', error);
                            }
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Error opening file in explorer:', error);
            Swal.fire({
                title: "Error",
                text: "Unable to open file location",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            });
        }
    };

    // Helper function to determine target audio field type
    const getTargetAudioFieldInfo = () => {
        let targetField = null;
        let shouldUseUrl = false;

        // Look for URL type fields with audio_upload flag
        for (const [key, field] of Object.entries(currentSchema)) {
            if (field.type === 'url' && field.audio_upload === true) {
                targetField = { key, field };
                shouldUseUrl = true;
                console.log(`[Audio] Found URL field with audio_upload: ${key}`);
                break;
            }
        }

        return { targetField, shouldUseUrl };
    };

    const handleUseAudio = async () => {
        const { targetField, shouldUseUrl } = getTargetAudioFieldInfo();

        if (!targetField) {
            console.warn('[Audio] No suitable audio field found in current schema');
            return;
        }

        console.log(`[Audio] Target field: ${targetField.key}, type: ${targetField.field.type}, shouldUseUrl: ${shouldUseUrl}`);

        let audioData = props.image;
        const isAudioUrl = props.image && (props.image.startsWith('http://') || props.image.startsWith('https://'));

        // If we should use URL and the audio is already a URL, send it directly
        if (shouldUseUrl && isAudioUrl) {
            console.log('[Audio] Sending URL directly to form field');
            audioData = props.image;
        }
        // If we should use URL but audio is base64, try to fetch URL from API
        else if (shouldUseUrl && !isAudioUrl && props.uid && props.hash) {
            try {
                console.log('[Audio] Audio is base64 but target requires URL, fetching from API...');
                const result = await getGenerateOutput(props.uid, props.hash);

                if (result.url && result.url.trim() !== '') {
                    console.log('[Audio] Successfully retrieved URL from API:', result.url);
                    audioData = result.url;

                    if (!electronBridge.isElectron) {
                        // Update IndexedDB to store URL instead of base64 for future use
                        try {
                            const imagesUpdated = await db.images.where('hash').equals(props.hash).modify({ image: result.url });
                            console.log(`[Audio] Updated ${imagesUpdated} record(s) in db.images with URL`);

                            const collectedUpdated = await db.collectedImages.where('hash').equals(props.hash).modify({ image: result.url });
                            console.log(`[Audio] Updated ${collectedUpdated} record(s) in db.collectedImages with URL`);

                            // Update local state to refresh component display without gallery refresh
                            setLocalAudioOverride(result.url);
                        } catch (dbError) {
                            console.error('[Audio] Error updating IndexedDB with URL:', dbError);
                        }
                    }
                } else {
                    console.warn('[Audio] API returned no URL, falling back to base64');
                }
            } catch (error) {
                console.error('[Audio] Error fetching URL from API:', error);
            }
        }

        // Emit event for PromptHeader to receive the audio
        eventBus.emit('useAudio', {
            audio: audioData,
            uid: props.uid
        });
    };

  // Determine audio source - handle both URLs and base64 data
  // Use localAudioOverride if set (e.g., after fetching URL from API), otherwise use props.image
  const audioSource = localAudioOverride || props.image;
  let audioSrc;
  if (electronBridge.isElectron && audioSource && audioSource.includes(":\\")) {
      // Electron environment and file path (Windows or Unix)
      audioSrc = toFileUrl(audioSource);
  } else if (audioSource && audioSource.startsWith('http')) {
      // Remote URL
      audioSrc = audioSource;
  } else if (audioSource) {
      // Assume base64
      audioSrc = `data:audio/mp3;base64,${audioSource}`;
  }

  // Determine border color based on online status and model type
  const getBorderColor = () => {
    if (!props.online) {
        return 'border-white'; // Offline - white
    }

    if (props.uid.toLowerCase().includes("momm")) {
        return 'border-green-500'; // MOMM - green
    }

    return 'border-amber-500'; // Online non-MOMM - amber/orange
};

const borderColor = getBorderColor();

  return (
    <>
      <style jsx>{`
        .vertical-volume-slider {
          -webkit-appearance: none;
          appearance: none;
          background: transparent;
          outline: none;
        }

        .vertical-volume-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #f59e0b;
          cursor: pointer;
          border: 2px solid white;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
          position: relative;
          z-index: 30;
        }

        .vertical-volume-slider::-moz-range-thumb {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #f59e0b;
          cursor: pointer;
          border: 2px solid white;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }

        .vertical-volume-slider::-webkit-slider-track {
          -webkit-appearance: none;
          appearance: none;
          background: transparent;
          border: none;
          height: 4px;
        }

        .vertical-volume-slider::-moz-range-track {
          background: transparent;
          border: none;
          height: 4px;
        }

        .vertical-volume-slider:focus {
          outline: none;
        }

        .vertical-volume-slider:hover::-webkit-slider-thumb {
          background: #d97706;
          transform: scale(1.1);
        }
      `}</style>
      <div className="group relative w-fit h-full mx-auto">
        {/* Mobile Menu Button - Always visible on mobile */}
        {isMobile && (
            <button
                ref={menuButtonRef}
                onClick={() => setShowMobileToolbar(!showMobileToolbar)}
                className="absolute top-2 right-2 z-20 bg-dark-blue/80 backdrop-blur p-2 rounded-lg shadow-lg"
                title="Show options"
            >
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                </svg>
            </button>
        )}
        
        {/* Toolbar - Desktop: hover, Mobile: click toggle */}
        <div 
            ref={toolbarRef}
            className={`${
                isMobile 
                    ? (showMobileToolbar ? 'visible opacity-100' : 'invisible opacity-0')
                    : 'invisible group-hover:visible opacity-0 group-hover:opacity-100'
            } transition-all duration-200 absolute -top-5 z-10 left-0 right-0`}>
                <div className="bg-dark-blue/90 backdrop-blur flex flex-row flex-wrap justify-center self-center p-2 rounded gap-2 shadow-lg w-full">
                  {/* Toolbar content placeholder */}
                  <div className="h-8 w-full flex items-center justify-center text-white font-semibold">
                    {!props.isMyCollection ?
                                  <button className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={toggleCollection} title={`${props.inCollection ? "Remove from Collection" : "Add to Collection"}`}>
                                      {localInCollection ?
                                          <img src={cardInCollection} alt={"In Collection Icon"} className="w-5 h-5"/> 
                                      :
                                          <img src={cardAdd} alt={"Add to Collection Icon"} className="w-5 h-5"/>
                                      }
                                  </button> :
                                  <>
                                      <button className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={toggleCollection} title="Remove from Collection">
                                          <img src={cardInCollection} alt={"In Collection Icon"} className="w-5 h-5"/>
                                      </button>
      
                                      <button title={`${privateImage ? 'Make the audio file public': 'Make the audio file private'}`} className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} 
                                      onClick={handlePrivatePublic}
                                      >
                                      {privateImage ?
                                          <img src={cardPrivate} alt="Private Icon" className="w-5 h-5"/> 
                                      :
                                          <img src={cardPublic} alt="Public Icon" className="w-5 h-5"/>
                                      }
                                      </button>
                                  </>
                              }
                    {/* <button title="Describe Image" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleDescribeImage}>
                                  <img src={cardImageDescribe} alt={"Describe Icon"} className="w-5 h-5"/>
                              </button>           */}
                    <button title="Save Audio" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={() => setShowSaveDialog(!showSaveDialog)}>
                        <CardSave alt={"Save Icon"} className="w-5 h-5"/>
                    </button>
                    {hasAudioField && (
                        <button title="Use Audio" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleUseAudio}>
                            <img src={uploadIconWhite} alt={"Use Audio"} className="w-7 h-7"/>
                        </button>
                    )}
                    <button title="Tag Audio" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={handleTagging}>
                        <img src={cardTag} alt={"Tag Icon"} className="w-5 h-5"/>
                    </button>   
                    <button title="Delete Audio" className={"w-8 h-8 flex items-center justify-center hover:bg-dark-blue/50 rounded-lg transition"} onClick={deleteImage}>
                        <img src={cardRemove} alt={"Remove Icon"} className="w-5 h-5c"/>
                    </button>                 
                  </div>
                  {showSaveDialog ?
                        <div className="w-full flex flex-col gap-2 bg-dark-blue/90 backdrop-blur p-2 rounded-b">
                            <input type={"text"} className={"w-full rounded text-dark-blue p-2 text-sm"}
                                onChange={(e) => setDownloadName(e.target.value)} value={downloadName}
                                onFocus={(e) => e.target.select()}
                            />
                            <div className="w-full flex flex-row justify-center gap-4">
                            {props.image && !electronBridge.isElectron ? (
                                <>
                                    <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={() => downloadAudio('audio/mp3', 'mp3')}>.mp3</button>
                                    <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={downloadPrompt}>.prompt</button>
                                </>
                            ) : (
                                <>
                                    <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={downloadPrompt}>.prompt</button>
                                    <button className="bg-dark-blue/40 rounded-lg px-4 py-2 hover:bg-dark-blue transition" onClick={handleViewInExplorer}>View Audio</button>
                                </>
                            )} 
                            </div>
                        </div>
                        : null
                    }
                </div>
              </div>   
        <div
            className={`group w-full rounded-xl overflow-hidden relative border-4 bg-dark-blue ${borderColor}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
        {props.image ? (
          <>
            <img className={"w-full p-10"} src={SoundWave} alt='Help'/>
            <audio ref={audioRef} src={audioSrc} onTimeUpdate={updateProgress} onEnded={handleAudioEnd} />
            <p className="absolute top-2 left-0 w-full text-center font-medium text-base line-clamp-2 group-hover:hidden">{props.name}</p>

            <button
              className={`play-button absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
                        flex items-center justify-center
                        w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20
                        rounded-full bg-cyan/50 hover:bg-cyan/70 transition-all duration-200
                        ${showAudioControls ? 'visible opacity-100' : 'invisible opacity-0'}`}
              onClick={togglePlay}
            >
              {isPlaying ? 
                <img className="w-1/2 h-1/2" src={StopAudio} alt="Stop Icon" /> : 
                <img className="w-1/2 h-1/2" src={StartAudio} alt="Play Icon" />
              }
            </button>

            {/* Audio Controls Container */}
            <div className={`absolute bottom-0 left-0 w-full px-3 py-2 bg-black/50 flex flex-nowrap items-center gap-2 sm:gap-3 transition-all duration-200
                        ${showAudioControls ? 'visible opacity-100' : 'invisible opacity-0'}`}>
  
                {/* Current Time */}
                <span className="text-white text-xs sm:text-sm w-10 text-right">{formatTime(audioRef.current?.currentTime || 0)}</span>
                
                {/* Seek Bar */}
                <input
                    type="range"
                    className="flex-1 h-2 rounded-lg bg-gray-300 accent-amber-500 cursor-pointer appearance-none custom-slider-thumb"
                    value={progress}
                    onChange={handleSeek}
                    min="0"
                    max="100"
                />

                {/* Total Duration */}
                <span className="text-white text-xs sm:text-sm w-10">{formatTime(audioRef.current?.duration || 0)}</span>

                {/* Volume Icon with Vertical Slider */}
                <div className="relative flex items-center volume-control w-6 mr-1">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-7 h-7 text-white cursor-pointer"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowVolumeSlider((prev) => !prev);
                    }}
                    >
                    <path d="M4 9v6h4l5 5V4L8 9H4z"/>
                    </svg>

                    {/* Vertical Slider */}
                    <div
                    className={`absolute bottom-8 left-1/2 -translate-x-1/2 transition-all duration-200 ease-out
                        ${showVolumeSlider ? "opacity-100 scale-100" : "opacity-0 scale-0 pointer-events-none"}`}
                    onMouseLeave={() => setShowVolumeSlider(false)}
                    >
                    <div className="relative w-6 h-20 flex items-center justify-center">
                        {/* Background track */}
                        <div className="absolute w-2 h-20 bg-gray-300 rounded-lg pointer-events-none"></div>

                        {/* Volume fill indicator */}
                        <div
                            className="absolute bottom-0 w-2 bg-amber-500 rounded-lg transition-all duration-150 pointer-events-none"
                            style={{ height: `${volume * 100}%` }}
                        />

                        {/* Rotated slider input */}
                        <input
                            type="range"
                            className="vertical-volume-slider absolute cursor-pointer appearance-none bg-transparent w-20 h-4 origin-center transform -rotate-90"
                            value={volume}
                            onChange={handleVolumeChange}
                            min="0"
                            max="1"
                            step="0.01"
                            style={{
                                background: 'transparent',
                                zIndex: 20
                            }}
                        />
                    </div>
                    </div>
                </div>
            </div>
            {props.isMyCollection ?
                <div className={`absolute group-hover:hidden top-0 left-0 rounded px-3 py-2 bg-white/30 text-base`}>{visibility}</div>
            :
                null    
            }
            {props.model ?
                <div className={`absolute group-hover:hidden bottom-0 right-0 rounded-br px-3 py-2 bg-white/30 text-sm`}>{props.model}</div>
            :
                null
            }
            {tag ? 
                <div className={`absolute group-hover:hidden bottom-0 left-0 rounded-bl px-3 py-2 bg-white/30 text-sm`}>{tag}</div>
            :
                null
            }
          </>
        ) : (
          <p>Loading audio...</p>
        )}
      </div>
      <Modal open={open} onClose={() => setOpen(false)} center>
                            <h2 className="text-2xl mb-5 font-bold">Category</h2>
                            <p>
                                Edit the tags you would like to add with the image
                            </p>
                            <div className="flex flex-row items-center justify-between my-5">
                                <p className="place-content-start">Original Tag: <span className="font-bold">{tag}</span></p>
                                <div id="clearTags" className={"flex flex-row items-center place-content-end"}>
                                    <ToggleInput id={"clearTags"} onChange={() => handleClearTag()}/>
                                    <label htmlFor={"clearTags"}
                                            className={`inline-block ml-2 text-sm font-medium ${clearTags ? 'text-yellow' : 'text-dark-blue'} transition`}>Clear Tags?</label>
                                </div>
                            </div>
                            <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Category</label>
                                {/* <select name="existing" className={"rounded-lg text-dark-blue border border-dark-blue p-2 w-2/5"} value={tag} onChange={(e) => setTag(e.target.value)}>
                                    <option value={`${props.tag}`}>{props.tag}</option>
                                </select> */}
                                <Select options={options} components={animatedComponents} onChange={(e) => setSelectedOptions(e)} isMulti isClearable onKeyDown={(e) => handleEnter(e)}/>
                            </div>
                            <div className="flex flex-row items-center">
                                <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                                <h1 className="mx-4 font-bold text-xl">OR</h1>
                                <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                            </div>
                                <p>
                                    Type in a new category to have more ease in sorting your images
                                </p>
                                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Category</label>
                                    <input type="text" name="emailAddress" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Category"
                                    value={inputTag} onChange={(e) => setInputTag(e.target.value)} onKeyDown={(e) => handleEnter(e)}/>
                                </div>
                            <div className="flex flex-row justify-center gap-4">
                                <button onClick={() => editTagOnImage()} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                                    {tagLoading ?
                                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                            </svg>
                                        :
                                            null
                                    }
                                    Categorize
                                </button>
                                <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                            </div>
                        </Modal>  
          <Modal open={openDescribeImage} onClose={() => setOpenDescribeImage(false)} center>
                            <h2 className="text-2xl mb-5 font-bold">Image Description</h2>
                            <p style={{minWidth: '600px'}}>
                                {imageDescriptionLoading ? 
                                    <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                </svg> 
                                : 
                                    null
                                }
                                {/*
                                <div className="dot-container">
                                    <span className="text">Generating</span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                </div>
                                */}
                                {imageDescription}
                            </p>
                            <br></br>
                            <div>
                                <button className="me-3" title="Copy Description To Clipboard" onClick={() => copyDescriptionToClipboard(imageDescription, setClipboardMessage)}>
                                    <img src={cardCopyDescription} alt={"Copy Description To Clipboard Icon"}/>
                                </button>
                                <button className="me-3" title="Save As Prompt"
                                        onClick={() => downloadDescriptionAsPromptFile(imageDescription, downloadName)}>
                                    <img src={cardSaveDescription} alt={"Save As Prompt Icon"}/>
                                </button>
                                <button className="me-3" title="Populate Prompt" onClick={() => handlePromptPopulation()}>
                                    <img src={cardPopulatePrompt} alt={"Populate Prompt Icon"}/>
                                </button>
                                <span>{clipboardMessage}</span>
                            </div>
                        </Modal>
      </div>
  </>
  )
}